<div
  [ngClass]="hidden ? 'w-0 h-0 invisible pointer-events-none' : 'contents'"
  [attr.aria-hidden]="hidden">
  @switch (asset.state) {
    @case ('generating') {
      @if (generating) {
        <ng-container
          [ngTemplateOutlet]="generating"
          [ngTemplateOutletContext]="{
            $implicit: asset,
          }" />
      } @else {
        <p-message
          icon="pi pi-spin pi-spinner"
          severity="info"
          variant="simple">
          Video is being generated...
        </p-message>
      }
    }
    @case ('error') {
      @if (error) {
        <ng-container
          [ngTemplateOutlet]="error"
          [ngTemplateOutletContext]="{
            $implicit: asset,
          }" />
      } @else {
        <app-asset-error [error]="asset.error" />
      }
    }
    @case ('ready') {
      @if (ready) {
        <ng-container
          [ngTemplateOutlet]="ready"
          [ngTemplateOutletContext]="{
            $implicit: asset,
          }" />
      } @else {
        <app-video-asset-resource
          #resource
          [id]="clip.value.id"
          [resource]="asset.resource"
          [controls]="resourceProps.controls"
          [playOnHover]="resourceProps.playOnHover"
          [startAt]="clip.value.startAt"
          [endAt]="clip.value.endAt" />
      }
      <app-video-asset-metadata [metadata]="asset.metadata" />
    }
  }
</div>
